import { render, staticRenderFns } from "../NewsArticles.html?vue&type=template&id=73d2f91e&scoped=true&"
import script from "./NewsBackground.ts?vue&type=script&lang=ts&"
export * from "./NewsBackground.ts?vue&type=script&lang=ts&"
import style0 from "@/scss/components/news/_news.scss?vue&type=style&index=0&id=73d2f91e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d2f91e",
  null
  
)

export default component.exports